/**
 * `<SourceTile>` — one connector tile inside a group. Two modes:
 *  - live: clickable card that opens the relevant form/flow.
 *  - coming-soon: disabled card with a badge.
 */

import { Badge, Button, Card, CardContent } from "@cometchat-ai/ui-dashboard";
import { Plus } from "../../components/icons";
import { useTranslation } from "react-i18next";

import type { TileConfig } from "../groups";

export function SourceTile({
  tile,
  onOpen,
}: {
  tile: TileConfig;
  onOpen: (tile: TileConfig) => void;
}) {
  const { t } = useTranslation("onboarding");
  const comingSoon = tile.kind === "coming_soon";

  return (
    <Card
      className="h-full"
      data-testid={`onboarding-tile-${tile.id}`}
      aria-disabled={comingSoon || undefined}
    >
      <CardContent className="flex h-full flex-col items-start justify-between gap-3 p-4">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <span className="font-medium text-foreground">{tile.label}</span>
            {comingSoon ? (
              <Badge variant="secondary" className="text-xs">
                {t("tile.comingSoon")}
              </Badge>
            ) : null}
          </div>
        </div>
        {comingSoon ? null : (
          <Button
            variant="outline"
            size="sm"
            onClick={() => onOpen(tile)}
            data-testid={`onboarding-tile-open-${tile.id}`}
            aria-label={t("tile.openForm", { name: tile.label })}
          >
            <Plus className="mr-1.5 h-4 w-4" aria-hidden="true" />
            {tile.kind === "kb" ? t("tile.add") : t("tile.connect")}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
